document.addEventListener('DOMContentLoaded', () => {
  const tabsSelector = '.blog-categories__link';
  let controller;

  function setActiveTab(url) {
    document.querySelectorAll(tabsSelector).forEach((a) => {
      a.classList.toggle('active', a.href === url);
    });
  }

  async function loadCategory(url, push) {
    const grid = document.getElementById('blog-grid');
    if (!grid) {
      window.location.href = url;
      return;
    }

    controller?.abort();
    controller = new AbortController();
    grid.setAttribute('aria-busy', 'true');

    let html;
    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) throw new Error('bad response');
      html = await res.text();
    } catch (err) {
      if (err.name === 'AbortError') return;
      window.location.href = url;
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = doc.getElementById('blog-grid');
    if (!newGrid) {
      window.location.href = url;
      return;
    }

    document.getElementById('blog-grid').replaceWith(newGrid);
    document.title = doc.title;
    setActiveTab(url);

    if (push) history.pushState({ url }, '', url);
  }

  document.body.addEventListener('click', (event) => {
    const link = event.target.closest(tabsSelector);
    if (!link) return;
    event.preventDefault();
    if (link.classList.contains('active')) return;
    loadCategory(link.href, true);
  });

  window.addEventListener('popstate', (event) => {
    if (event.state?.url) loadCategory(event.state.url, false);
  });
});
